import { render, staticRenderFns } from "./label-input.vue?vue&type=template&id=e881f12a&scoped=true&"
import script from "./label-input.vue?vue&type=script&lang=js&"
export * from "./label-input.vue?vue&type=script&lang=js&"
import style0 from "./label-input.vue?vue&type=style&index=0&id=e881f12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e881f12a",
  null
  
)

export default component.exports